



































































import Vue from 'vue'
import {MSGR_VK, MSGR_TG, MSGR_MAX, MSGR_VB, MSGR_TT, MSGR_DC} from '@/constants'
import {StudentMsrgs} from '@/types/entity/RawStudent'
import {MsrgsSendStatus} from '@/types/entity/RawRecipient'

// @ts-ignore
import messages from '@/lang/index';

export const MSGRS: {[key: string]: {icon: string, color: string, label: string}} = {
  [MSGR_VK]: {
    icon: 'static/img/icons/msgrs/vk_new_white.svg',
    color: '#0077FF',
    label: messages.common.socials.vk
  },
  [MSGR_TG]: {
    icon: 'static/img/icons/msgrs/tg_white.svg',
    color: '#279DD4',
    label: messages.common.socials.tg
  },
  [MSGR_MAX]: {
    icon: 'static/img/icons/msgrs/max.png',
    color: '',
    // label: messages.common.socials.max
    label: 'MAX'
  },
  [MSGR_VB]: {
    icon: 'static/img/icons/msgrs/vb_white.svg',
    color: '#8527B4',
    label: messages.common.socials.vb
  },
  [MSGR_TT]: {
    icon: 'static/img/icons/msgrs/tt_white.svg',
    color: '#697CFF',
    label: messages.common.socials.tt
  },
  [MSGR_DC]: {
    icon: 'static/img/icons/msgrs/discord_white.svg',
    color: '#5865F2',
    label: messages.common.socials.dc
  },
}
export default Vue.extend({
  props: {
    msgrs: {} as () => StudentMsrgs,
    sendStatus: {} as () => MsrgsSendStatus,
    size: {
      type: Number,
      default: 18
    },
    inCols: Boolean,
    scope: {}
  },
  methods: {
    getPath (name: string): string {
      return MSGRS[name].icon;
    },
    getColor (name: string): string | undefined {
      return MSGRS[name].color || undefined;
    },
    getLabel (name: string): string {
      return MSGRS[name].label;
    },
    isOk (name: string): boolean {
      if (this.sendStatus) {
        // @ts-ignore
        return this.sendStatus[name] && this.sendStatus[name].ok || false
      } else {
        return false;
      }
    },
    isError (name: string): boolean {
      if (this.sendStatus) {
        // @ts-ignore
        return this.sendStatus[name] && this.sendStatus[name].ok === false || false
      } else {
        return false;
      }
    }
  },
  computed: {
    marginRight (): number {
      return this.size * 0.3;
    }
  }
})
